export const ENV = {
  DEV :'dev',
  STAGING: "staging",
  PRODUCTION: "production",
  UAT: "uat"
};

export const TYPE = {
  LAPTOP: "Notebook",
  DESKTOP: "Desktop",
  AIO: "AIO"
};

export const DOWNLOAD = {
  INIT: "Repack",
  READY: "ZIP",
  Executable: "EXE",
  SCCM: "SCCM",
  PROCESSING: "Processing"
};

export const MODAL = {
  400: "I01",
  404: "page_not_exit",
  405: "I03",
  DOWNLOADBROKEN: "down_load_broken",
  500: "I02",
  502: "requestTimeout",
  download403: "download403",
  download404: "download404",
  NOINTERNETCON: "No_internet_connection"
};

export const EMAIL = {
  TW: "#TW_Tech_Expert@asus.com",
  TH: "#TH_Tech_Expert@asus.com"
};

export const PACKAGE = {
  LiteCD: "Driver Package",
  SCCM: "SCCM"
};

export const CATEGORY = {
  LiteCD: "Driver Package",
  SCCM: "SCCM",
  "Driver Package": "Driver Package",
  Executable: "EXE"
};

export const FORBITURL = [
  "/users/me/survey-required/",
  "/notifications/",
  "/upvote",
  "/downvote",
  "/users/pin/",
  "/download-release-notes/",
  "/repack/",
  "/download/"
];

export const PAGEINDEX = {
  CREATE: "Create New",
  EXPORTHISTORY: "Export History",
  DOWNLOAD: "Download",
  EXPORTHISTORYDETAIL: "Export History Detail"
};

export const WEEKSTRING = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday"
};

export const DRIVERCATEGORYSTORE = {
  USB: "__usb",
  Audio: "__audio",
  Chipset: "__chipset",
  'Software and Utility': "__softwareAndUtility",
  Bluetooth: '__bluetooth',
  Camera : '__camera',
  "Card Reader" : '__cardReader',
  "Pointing Device" : '__pointingDevice',
  Graphics : '__graphics',
  "Biometric Authentication" : '__biometricAuthemtication',
  Networking : '__networking',
  Firmware : '__firmware',
};

export const DRIVERWINDOWSKBSTORE = {
  'Critical update': "__e5H7.__criticalUpdate",
  'Definition update': "__e5H7.__definitionUpdate",
  'Feature pack': "__e5H7.__featurePack",
  'Security update': "__e5H7.__securityUpdate",
  'Tool': '__common.__tool',
  'Update' : '__common.__update',
  'Servicing Stack Updates (SSU)': '__c6N3.__servicingStackUpdatesSsu',
};

export const LANG = {
  en: 'en-US',
  tw: 'zh-TW',
  th: 'th-TH',
  fr: 'fr-FR',
  ja: 'ja-JP',
  zh: 'zh-CN',
  pt_rbr: 'pt-BR'
}

export const DOMAINURL = {
  dev : 'bpza003kjc.corpnet.asus',
  staging : ".corpnet.asus",
  uat : ".asus.com",
  production : ".asus.com",
}
